import { signal } from 'services/SignalsService'

export default class FoodReelsEntity extends PIXI.Container {
  constructor() {
    super()
    this.reels = []

    signal.on('FoodReelsEntity:START', this.start.bind(this))
  }
  async start() {
    signal.dispatch('REELS-START')
    await signal.promise('ACTION:REEL-SPIN')
    await Promise.all(this.reels.map((reel) => reel.start()))
    signal.dispatch('REELS-STOP')
  }

  register = (type, object) => {
    if (type == 'FoodReel') {
      this.reels.push(object)
    }
  }
}
